module.exports = __webpack_public_path__ + "img/usability-3.7e9de8be.png";